(function () {
  'use strict';

  var feedLoaded = false;
  var feedPayload = null;
  var consentChecks = 0;

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function preferencesAllowed() {
    try {
      return !!(
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.preferencesProcessingAllowed === 'function' &&
        window.Shopify.customerPrivacy.preferencesProcessingAllowed()
      );
    } catch (error) {
      return false;
    }
  }

  function preferencesKnown() {
    return !!(
      window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.preferencesProcessingAllowed === 'function'
    );
  }

  function currentWardrobeReady() {
    if (!window.PrewornWardrobe ||
        typeof window.PrewornWardrobe.getWardrobe !== 'function') return false;
    var wardrobe = window.PrewornWardrobe.getWardrobe();
    return !!(wardrobe && Array.isArray(wardrobe.categories) && wardrobe.categories.length);
  }

  function arrangeShoppingOrder(section) {
    var home = section.closest ? section.closest('.pwhome') : null;
    if (!home || String(home.getAttribute('data-department-focus') || '')) return;
    var hero = home.querySelector('.pwhome__hero');
    var newIn = home.querySelector('.pwhome__new-in-section');
    var wardrobe = home.querySelector('[data-pwhome-wardrobe-feature]');
    var colour = home.querySelector('.pwhome__colour-shop');
    if (!hero || !newIn) return;

    // Reorder the actual DOM so visual, keyboard and screen-reader order agree.
    home.insertBefore(newIn, hero.nextSibling);
    home.insertBefore(section, newIn.nextSibling);
    if (wardrobe) home.insertBefore(wardrobe, section.nextSibling);
    if (colour) home.insertBefore(colour, wardrobe ? wardrobe.nextSibling : section.nextSibling);
  }

  function setView(section, name) {
    var search = section.querySelector('[data-pwhome-personalisation-search]');
    var prompt = section.querySelector('[data-pwhome-personalisation-prompt]');
    if (search) search.hidden = name !== 'search';
    if (prompt) prompt.hidden = name !== 'prompt';
    section.hidden = name === 'hidden';
  }

  function showPrompt(section) {
    if (currentWardrobeReady()) {
      setView(section, 'hidden');
      return;
    }
    setView(section, 'prompt');
  }

  function renderIntents(section, payload) {
    var intents = payload && Array.isArray(payload.intents) ? payload.intents : [];
    if (!intents.length || currentWardrobeReady()) {
      showPrompt(section);
      return;
    }
    var target = section.querySelector('[data-pwhome-personalisation-intents]');
    var manage = section.querySelector('[data-pwhome-personalisation-manage]');
    if (manage && payload.manageUrl) manage.href = payload.manageUrl;
    if (target) {
      target.innerHTML = intents.map(function (intent, index) {
        var resultCount = Math.max(0, Number(intent.resultCount) || 0);
        return '<a class="pwhome__personalisation-intent' +
          (index === 0 ? ' is-active' : '') + '" href="' +
          escapeHtml(intent.url || '/search?q=' + encodeURIComponent(intent.query || '')) + '">' +
          '<span>' + escapeHtml(intent.query) + '</span>' +
          '<small>' + resultCount.toLocaleString('en-GB') + ' matches</small>' +
          '<i aria-hidden="true">↗</i></a>';
      }).join('');
    }
    setView(section, 'search');
    renderProducts(section, intents[0]);
  }

  function catalogueUrl(section, intent) {
    var url = new URL(section.getAttribute('data-catalog-api'), window.location.href);
    url.searchParams.set('action', 'search');
    url.searchParams.set('q', String(intent.query || ''));
    url.searchParams.set('page', '1');
    url.searchParams.set('limit', '4');
    url.searchParams.set('sort', 'newest');
    url.searchParams.set('include_facets', '0');
    url.searchParams.set('count_mode', 'none');
    if (intent.contextType === 'collection') {
      var match = String(intent.url || '').match(/^\/collections\/([a-z0-9-]+)/i);
      if (match) url.searchParams.set('collection', match[1]);
    }
    return url.toString();
  }

  function renderProducts(section, intent) {
    var target = section.querySelector('[data-pwhome-personalisation-products]');
    var query = section.querySelector('[data-pwhome-personalisation-query]');
    var viewAll = section.querySelector('[data-pwhome-personalisation-view-all]');
    var results = section.querySelector('.pwhome__personalisation-results');
    if (results) results.hidden = false;
    if (query) query.textContent = '“' + String(intent.query || '') + '”';
    if (viewAll) viewAll.href = intent.url || '/search?q=' + encodeURIComponent(intent.query || '');
    if (!target || typeof window.fetch !== 'function') return;
    target.setAttribute('aria-busy', 'true');
    target.innerHTML = '<li class="pwhome__personalisation-loading">Finding the newest matches…</li>';

    window.fetch(catalogueUrl(section, intent), {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Catalogue HTTP ' + response.status);
      return response.json();
    }).then(function (payload) {
      var items = payload && Array.isArray(payload.items) ? payload.items.slice(0, 4) : [];
      var renderer = window.PrewornProductCards;
      if (!items.length || !renderer || typeof renderer.renderList !== 'function') {
        target.innerHTML = '';
        if (results) results.hidden = true;
        return;
      }
      target.innerHTML = renderer.renderList(items);
      if (typeof renderer.bindWishlist === 'function') renderer.bindWishlist(target);
    }).catch(function () {
      target.innerHTML = '';
      if (results) results.hidden = true;
    }).then(function () {
      target.setAttribute('aria-busy', 'false');
    });
  }

  function loadFeed(section) {
    if (section.getAttribute('data-customer') !== 'true') return;
    if (feedLoaded) {
      if (feedPayload) renderIntents(section, feedPayload);
      else showPrompt(section);
      return;
    }
    if (!preferencesKnown()) {
      consentChecks += 1;
      if (consentChecks < 8) {
        window.setTimeout(function () { loadFeed(section); }, 400);
      } else {
        showPrompt(section);
      }
      return;
    }
    if (!preferencesAllowed()) {
      showPrompt(section);
      return;
    }
    feedLoaded = true;
    window.fetch(section.getAttribute('data-home-feed-url'), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Homepage feed HTTP ' + response.status);
      return response.json();
    }).then(function (payload) {
      feedPayload = payload || {};
      renderIntents(section, feedPayload);
    }).catch(function () {
      feedPayload = null;
      showPrompt(section);
    });
  }

  function bindColourDisclosure(section) {
    var home = section.closest ? section.closest('.pwhome') : null;
    var colour = home ? home.querySelector('.pwhome__colour-shop') : null;
    var button = colour ? colour.querySelector('[data-pwhome-colour-toggle]') : null;
    if (!colour || !button) return;
    colour.classList.add('is-collapsible');
    button.addEventListener('click', function () {
      var expanded = !colour.classList.contains('is-expanded');
      colour.classList.toggle('is-expanded', expanded);
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      var label = button.querySelector('[data-pwhome-colour-toggle-label]');
      if (label) label.textContent = expanded ? 'SHOW FEWER COLOURS' : 'EXPLORE ALL COLOURS';
    });
  }

  function init() {
    var section = document.querySelector('[data-pwhome-personalisation]');
    if (!section) return;
    arrangeShoppingOrder(section);
    bindColourDisclosure(section);

    var build = section.querySelector('[data-pwhome-personalisation-build]');
    if (build) {
      build.addEventListener('click', function () {
        if (!window.PrewornWardrobe) return;
        if (typeof window.PrewornWardrobe.createWardrobe === 'function') {
          window.PrewornWardrobe.createWardrobe();
        } else if (typeof window.PrewornWardrobe.open === 'function') {
          window.PrewornWardrobe.open();
        }
      });
    }

    if (currentWardrobeReady()) {
      setView(section, 'hidden');
    } else if (section.getAttribute('data-customer') === 'true') {
      loadFeed(section);
    } else {
      showPrompt(section);
    }

    window.addEventListener('preworn:wardrobe-change', function () {
      if (currentWardrobeReady()) setView(section, 'hidden');
      else if (section.getAttribute('data-customer') === 'true') loadFeed(section);
      else showPrompt(section);
    });
    window.addEventListener('preworn:search-profile-cleared', function () {
      feedLoaded = true;
      feedPayload = null;
      showPrompt(section);
    });
    document.addEventListener('visitorConsentCollected', function () {
      feedLoaded = false;
      feedPayload = null;
      loadFeed(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
